import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import classNames from 'classnames';
import { FC, memo } from 'react';
import { useNavigate } from 'react-router-dom';

import archiveIcon from '~/ui/assets/images/archiveIcon.svg';
import editIcon from '~/ui/assets/images/editGrey.svg';
import Button from '~/ui/components/common/Button';
import Status from '~/ui/components/common/Status';

import { IClient } from '~/services/api/client/types';
import { IClientsFilters } from '~/store/client/types';
import { EDIT_CLIENT } from '~/ui/constants/paths';
import extractFullName from '~/utils/text/extractFullName';

import { ClientAction, IClientAction } from '../../reusable/Table/types';
import getCurrentClientTeams from '../../reusable/Table/utils';

import styles from '../../reusable/Table/Table.module.scss';

interface IProps {
  item: IClient;
  filters: Partial<IClientsFilters>;
  setClientAction: (action: IClientAction) => void;
}

const ClientManagementTableBody: FC<IProps> = ({ item, filters, setClientAction }) => {
  const navigate = useNavigate();
  const clientTeam =
    item.teams.find(team => filters?.teams.includes(team.team.id)) ||
    item.teams.find(t => t.isPrimary) ||
    item.teams[0];

  const { archived, active } = getCurrentClientTeams(item.teams, {
    teams: filters.teams,
    status: filters.status,
  });

  return (
    <>
      <TableCell>
        {active.map(team => (
          <div key={team.team.id}>{team.team.name}</div>
        ))}
        {archived.map(team => (
          <div key={team.team.id}>{team.team.name}</div>
        ))}
      </TableCell>
      <TableCell>
        {active.map(team => (
          <Status key={team.team.id} isArchived={team.isArchived} />
        ))}
        {archived.map(team => (
          <Status key={team.team.id} isArchived={team.isArchived} />
        ))}
      </TableCell>

      <TableCell className={styles.actionsCell}>
        {active.length > 0 && (
          <div>
            <IconButton
              onClick={() =>
                navigate(
                  EDIT_CLIENT.replace(':clientId', String(item.id)).replace(
                    ':actTeamId',
                    String(clientTeam?.team.id),
                  ),
                  {
                    state: {
                      actTeamId: String(clientTeam?.team.id),
                    },
                  },
                )
              }
            >
              <img src={editIcon} alt="editIcon" />
            </IconButton>
            <IconButton
              onClick={() => setClientAction({ action: ClientAction.ARCHIVE, client: item })}
            >
              <img src={archiveIcon} alt="archiveIcon" />
            </IconButton>
          </div>
        )}
        {archived.length > 0 && (
          <Tooltip
            title={
              item.transferredToClient
                ? `${extractFullName(item.transferredToClient)} was transferred to ${
                    item.transferredToClient.team?.name
                  } team and can not be restored.`
                : ''
            }
            disableHoverListener={!item.transferredToClient}
          >
            <Button
              onClick={
                item.transferredToClient
                  ? undefined
                  : () => setClientAction({ action: ClientAction.RESTORE, client: item })
              }
              className={classNames({
                [styles.disabledButton]: item.transferredToClient,
              })}
            >
              Restore
            </Button>
          </Tooltip>
        )}
      </TableCell>
    </>
  );
};

export default memo(ClientManagementTableBody);
